
export default function Merits() {
  const merits = [
    {
      icon: 'ri-shield-check-line',
      title: 'デポジット型だから審査が不安な方も安心！',
      description: 'デポジット型クレジットカードは保証金（デポジット）をお預けいただくことで、審査が不安な方でもご入会いただきやすいクレジットカードです。フリーランス、個人事業主の方、過去にカード審査で嫌な思いをした方にも強い味方。デポジット額がそのまま利用限度額となるため、使いすぎる心配もありません。',
      highlight: '審査が不安な方、個人事業主・フリーランスの方におすすめ！',
    },
    {
      icon: 'ri-bank-card-line',
      title: 'キャッシュレスで便利！ネットショッピングも対応',
      description: 'Mastercardブランドなので、世界中のMastercard加盟店で利用可能。ネットショッピングはもちろん、実店舗でのお買い物、公共料金（電気・ガス）や通信料のお支払いにも使えます。支払いは口座振替とコンビニ払いから選べて、「みんなリボ」に登録すれば毎月定額のお支払いで安心です。',
      highlight: 'Mastercard加盟店で世界中どこでも使える！',
    },
    {
      icon: 'ri-gift-line',
      title: 'ポイントが貯まってお得！',
      description: 'お買い物はもちろん、公共料金や通信料のお支払いでもポイントが貯まります。200円ごとに1ポイント（還元率0.5%）が付与され、1ポイント=1円としてデジコのデジタルギフトに交換可能。Web会員サービスに登録すれば、スマホやパソコンから利用明細の確認やポイント交換申込ができます。',
      highlight: '貯まったポイントはデジタルギフトに交換可能！',
    },
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-[#E3F2FD] to-[#F8F9FA]">
      <div className="max-w-5xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-[#003366] mb-3 text-center">
          デポジット型クレジットカードの3つのメリット
        </h2>
        <p className="text-gray-600 text-center mb-12">デポジット型だから安心・便利・お得！</p>

        <div className="space-y-6">
          {merits.map((merit, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-6 md:p-8 hover:shadow-xl transition-shadow">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#0099CC] rounded-full flex-shrink-0">
                  <i className={`${merit.icon} text-white text-xl`}></i>
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-3 flex-wrap">
                    <span className="bg-[#003366] text-white text-xs font-bold px-3 py-1 rounded-full">
                      メリット{index + 1}
                    </span>
                    <h3 className="text-lg md:text-xl font-bold text-[#003366]">{merit.title}</h3>
                  </div>
                  <p className="text-gray-700 text-sm md:text-base leading-relaxed mb-3">
                    {merit.description}
                  </p>
                  <div className="bg-[#E3F2FD] border-l-4 border-[#0099CC] px-4 py-2 rounded">
                    <p className="text-[#003366] text-xs md:text-sm font-medium">
                      <i className="ri-information-line mr-1"></i>
                      {merit.highlight}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
